import React from 'react';
import { Button, Col, Row } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import AccountHeader from '../../common/components/AccountHeader';
import RightSection from '../../common/components/RightSection';

import { Layout as AntLayout } from 'antd';
import './Welcome.less';
import '../../App.less';

interface Props {
  onSubmit: () => void;
}

const Welcome: React.FC<Props> = ({ onSubmit }) => {
  const headerItems: string[] = ['Hassle Free', 'Flexible', 'Compliant'];
  return (
    <AntLayout>
      <AntLayout.Content>
        <Row className="height-100">
          <Col xs={14}>
            <AccountHeader />

            <Row>
              <Col span={14} offset={6} className="mt-64">
                <div>
                  <h2 className="title">
                    ICHRA Affordability Tool for Employees
                  </h2>
                </div>
                <div>
                  <p className="color-gray-8 font-large-text">
                    Fill in your information to get help understanding if you
                    should “opt-in” to the Individual Coverage HRA (ICHRA)
                    benefit being offered to you by your employer. It’s
                    important you make an informed decision!
                    <br />
                    <br />
                    <br />
                    <i>
                      Note: If you are an employer (or broker) trying to design
                      an affordable ICHRA benefit for your employees, we have a
                      different decision support tool just for you. Please
                      contact sales to start.
                    </i>
                  </p>
                </div>
                <div className="mt-32">
                  <Button
                    type="primary"
                    className="full-width button__large"
                    onClick={onSubmit}
                  >
                    Get started
                    <ArrowRightOutlined />
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={8} className="account-right-section-login">
            <RightSection
              headerTitle={'Individual Coverage HRA'}
              headerItems={headerItems}
            />
          </Col>
        </Row>
      </AntLayout.Content>
    </AntLayout>
  );
};

export default Welcome;
